import React, { useCallback } from "react";

import { useStoredDataDispatch } from "@/store";
import useGetOverlay from "@/store/hooks/useGetOverlay";

import LayoutSidebarModeRightBase from "@/components/Layout/Sidebar/Mode/RightBase";
import { twMerge } from "tailwind-merge";

import { MenuDrawer, type MenuDrawerProps } from "./Base";

export function MobileLayoutDrawersRightSidebar(props: Omit<MenuDrawerProps, "children" | "orientation">) {
  const storedDispatch = useStoredDataDispatch();

  const overlay = useGetOverlay();

  const handleClose = useCallback(() => {
    storedDispatch({ type: "closeOverlay" });
  }, [storedDispatch]);

  return (
    <MenuDrawer {...props} orientation="right" onClose={handleClose} open={overlay !== undefined} contentClassName={twMerge("flex flex-col justify-start", props.contentClassName)}>
      <LayoutSidebarModeRightBase className="overflow-y-auto px-4 py-0" headerClassName="sticky w-full bg-neutral" />
    </MenuDrawer>
  );
}
